import React from "react";
import { AlertTriangle } from "lucide-react";
import Markdown from "@/components/mongo/Markdown";
import MongoSteps from "@/components/mongo/MongoSteps";

export default function ChatMessage({ msg, index, live = false }) {
    if (msg.role === "user") {
        return (
            <div className="flex justify-end" data-testid={`ask-msg-user-${index}`}>
                <div className="max-w-[75%] bg-white/10 border border-white/10 rounded-lg rounded-br-sm px-4 py-2.5 text-sm text-white whitespace-pre-wrap">{msg.content}</div>
            </div>
        );
    }
    return (
        <div className="max-w-[90%] space-y-3" data-testid={live ? "ask-msg-live" : `ask-msg-assistant-${index}`}>
            <MongoSteps steps={msg.steps} title="Lookups" testId={live ? "ask-live-steps" : `ask-steps-${index}`} />
            {(msg.notices || []).map((n, i) => (
                <div key={i} className="text-xs text-amber-300 flex items-center gap-1.5" data-testid="ask-notice"><AlertTriangle className="w-3.5 h-3.5" /> {n}</div>
            ))}
            {msg.content ? (
                <div className="bg-[#0a0a0a] border border-white/10 rounded-lg rounded-bl-sm px-4 py-3">
                    <Markdown text={msg.content} testId={live ? "ask-live-answer" : `ask-answer-${index}`} />
                    {live && <span className="inline-block w-1.5 h-4 bg-[#A78BFA] animate-pulse align-middle ml-0.5" />}
                </div>
            ) : live ? (
                <div className="text-xs text-white/40 font-mono flex items-center gap-2" data-testid="ask-thinking">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#A78BFA] animate-ping" /> Looking it up…
                </div>
            ) : null}
            {msg.error && <div className="text-xs text-red-300 border border-red-400/30 bg-red-500/5 rounded-md px-3 py-2" data-testid={`ask-error-${index}`}>{msg.error}</div>}
        </div>
    );
}
